Librarian.DisclosureWindow = new Class({
    Extends: Librarian.GridWindow,

    options: {
        id: "DisclosureWindow",
        title: "Disclosure Window",
        width: 850,
        height: 590,
        type: 0
    },

    initialize: function(options) {
        this.setOptions(options, {
            title: Librarian.Lang.getString("disclosure_title"),
            gridOptions: this.getGridOptions()
        });

        this.parent(this.options);
    },

    getGridOptions: function() {
        var url = Librarian.path.getMethodUrl("getdiscs") + "&out=dgrid&type=" + this.options.type;

        var gridOptions = {
            url: url,
            width: 800,
            columnModel: [
                {
                    header: "✔",
                    dataType: "checkbox",
                    width: 25,
                    onChange: true,
                    noResize: true
                },
                {
                    header: Librarian.Lang.getString("id"),
                    dataIndex: "disclosureid",
                    dataType: "number",
                    width: 40,
                    noResize: true
                },
                {
                    header: Librarian.Lang.getString("name"),
                    dataIndex: "name",
                    dataType: "string",
                    width: 139,
                    noResize: true
                },
                {
                    header: Librarian.Lang.getString("disclosure_content"),
                    dataIndex: "content",
                    dataType: "string"
                }
            ]
        }

        return gridOptions;
    }
});
 